import polyglotI18nProvider from "ra-i18n-polyglot";
import customEnglishMessages from "./en";
import customChineseMessages from "./zh";

const translations = {
  en: customEnglishMessages,
  zh: customChineseMessages,
};

const defaultLocale = localStorage.getItem("app_locale") || "en";

const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale],
  defaultLocale,
  [
    { locale: "en", name: "English" },
    { locale: "zh", name: "中文" },
  ],
  { allowMissing: true }
);

const originalChangeLocale = i18nProvider.changeLocale;

i18nProvider.changeLocale = (newLocale) => {
  localStorage.setItem("app_locale", newLocale);
  return originalChangeLocale(newLocale);
};

export default i18nProvider;
